import Block from '../../common.blocks/block'

export default class CheckoutForm extends Block {
	static title = 'checkout-form'

	constructor($el) {
		super($el)

		this.button = this.$el.findElement('button-selects')
		this.addressForm = this.$el.findElement('address-selects')

		if (this.button) {
			this.button.on('click', () => {
				if (this.addressForm.is(':visible')) {
					this.addressForm.addClass('checkout-form__address-selects--hidden')
					this.button.text(this.button.data('text'))
				} else {
					this.addressForm.removeClass('checkout-form__address-selects--hidden')
					this.button.text(this.button.data('close'))
				}
			})
		}

		if (this.addressForm) {
			this.addressForm.on('change', () => {
				this.addressForm.submit()
			})
		}
	}
}
